import * as React from 'react';
export const AWSvg = React.forwardRef(function AWSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F4B32E',
        d: 'M0 7h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 9V6h1v3h-1ZM0 6h1v3H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M1.994 0h12.012C15.106 0 16 .896 16 2.001V7H0V2.001A2 2 0 0 1 1.994 0ZM0 8h16v1H0V8Zm0 2h16v1c0 .556-.448 1-1 1H1c-.555 0-1-.448-1-1v-1Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 3.5,
        cy: 3.5,
        r: 1.5,
        fill: '#E25950',
      }),
    ),
  );
});
AWSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var AW = {
  category: 'flag',
  colorable: false,
  name: 'AW',
  svg: AWSvg,
};
